require('./brokerTransferPensionPlansExternalStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @commons
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
// @Components
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { BrokerAdvancedSearchExplore } = require('components/broker/brokerAdvancedSearch/brokerAdvancedSearchExplore/brokerAdvancedSearchExplore');
const UploadedExtractRow = require('./uploadedExtractRow/uploadedExtractRow');
const { ContractDisclaimerPersonalInfo } = require('routes/contractsView/components/ContractDisclaimerPersonalInfo/ContractDisclaimerPersonalInfo');

const {
    VALID_TYPES_FILE,
    FILE_SIZE_LIMIT_EXTERNAL_TRANSER,
    FILE_TYPES,
    FILE_NAME_CHARS_LIMIT,
    FILE_NUMBER_LIMIT,
} = require('constants/fileRequirements');
const ALTERED_FILE_TYPES = FILE_TYPES.map((type) => {
    let file_type = type;
    if(type.toLowerCase() === VALID_TYPES_FILE.JPEG) {
        file_type = VALID_TYPES_FILE.JPG
    }
    return file_type;
});
const FILE_NAME_REGEX = /^[a-z0-9]+\.[a-z0-9]{3,4}$/ig;

const texts = {
    sizeError: <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_fileUploadSizeError" injectedStrings={[FILE_SIZE_LIMIT_EXTERNAL_TRANSER/1000]} />,
    typeError: <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_fileUploadTypeError" injectedStrings={[ALTERED_FILE_TYPES.join(', ').toUpperCase()]} />,
    maxLengthError: <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_fileUploadNameLengthError" injectedStrings={[FILE_NAME_CHARS_LIMIT]} />,
    whiteListError: <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_fileUploadNameFormatError"/>,
    duplicateFileNameError: <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_fileUploadDuplicateNameError"/>
}

class BrokerTransferPensionPlansExternalStep1 extends React.Component {

    constructor(props){
        super(props);
        this.handleUpload = this.handleUpload.bind(this);
    }

    handleUpload(fileState) {
        this.props.addFile(fileState);
    }

    createUpload() {
        const { immStep } = this.props;
        const filesAttached = immStep.get('filesAttached');
        let uploadFragment = null;
        let fileNameList = filesAttached.get('name');
        if ( !immStep.get('extractLoaded') ) {
            uploadFragment = (
                <div className="row">
                    <div className="broker-transfer-pension-plans-external-step1__upload-section col-xs-6">
                        <DragNDropUpload
                            attachedFileList={fileNameList}
                            checkDuplicateFileName={true}
                            errorIconClass="icon-error broker-transfer-pension-plans-external-step1__icon broker-transfer-pension-plans-external-step1__icon--error"
                            errorMessage=""
                            fileText=""
                            hideFormats={true}
                            hideShowAttachLink={true}
                            hideSizeLimit={true}
                            hideSuccessState={true}
                            hideUploadedFileList={true}
                            iconClass="icon-subir broker-transfer-pension-plans-external-step1__icon"
                            idName=""
                            isModern={true}
                            isTrashVisible={true}
                            maxLengthFileName={FILE_NAME_CHARS_LIMIT}
                            maxSize={FILE_SIZE_LIMIT_EXTERNAL_TRANSER}
                            onChange={this.handleUpload}
                            overwriteFile={true}
                            textDescription={formatText('externalTransferPlanStep1-dropBoxLabel')}
                            textLinkDescription={formatText('externalTransferPlanStep1-dropBoxLink')}
                            texts={texts}
                            title=""
                            validTypesFile={FILE_TYPES}
                            whiteListFileNameCharsRegExp={FILE_NAME_REGEX}
                        />
                    </div>
                </div>
            );
        }
        return uploadFragment;
    }

    uploadDocumentSection(){
        const { immStep, removeFile, setDescription } = this.props;
        const filesAttached = immStep.get('filesAttached');
        const documentSection = (
            <div className="broker-transfer-pension-plans-external-step1">
                <h2 className="broker-transfer-pension-plans-external-step1__heading">
                    <FormattedText value="externalTransferPlanStep1-heading"/>
                </h2>
                <FormattedText value="externalTransferPlanStep1-subHeading" className="broker-transfer-pension-plans-external-step1__paragraph"/>

                <div className="broker-transfer-pension-plans-external-step1__intructions">
                    <p className="broker-transfer-pension-plans-external-step1__intruction">
                        <FormattedText value="externalTransferPlanStep1-maximumFilesText"/>
                        <span className="broker-transfer-pension-plans-external-step1__intruction-value">{FILE_NUMBER_LIMIT}</span>
                    </p>
                    <p className="broker-transfer-pension-plans-external-step1__intruction">
                        <FormattedText value="externalTransferPlanStep1-maximumSizeText"/>
                        <span className="broker-transfer-pension-plans-external-step1__intruction-value">{FILE_SIZE_LIMIT_EXTERNAL_TRANSER/1000}MB</span>
                    </p>
                    <p className="broker-transfer-pension-plans-external-step1__intruction">
                        <FormattedText value="externalTransferPlanStep1-fileTypeText"/>
                        <span className="broker-transfer-pension-plans-external-step1__intruction-value">{ALTERED_FILE_TYPES.map((element) => element.toUpperCase()).join(', ')}.</span>
                    </p>
                </div>
                {immStep.get('extractLoaded') ? (
                    <section className="broker-transfer-pension-plans-external-step1__file-upload-section">
                        <UploadedExtractRow
                            fileData={filesAttached}
                            removeFile={removeFile}
                            setDescription={setDescription}
                        />
                    </section>): null
                } 
                {this.createUpload()}
                <ContractDisclaimerPersonalInfo
                    cssModifier="broker-transfer-pension-plans-external-step1__link"
                    linkTextKey="accountDirectDebitLinkText"
                    linkUrlKey="accountDirectDebitLinkUrl"
                    messageKey="externalTransferExtractMsg"
                />
            </div>
        );
        return documentSection;
    }

    render(){
        const { immStep, handlePlanSelectFromSearch, walletPlans } = this.props;
        const planSelected = immStep.get('planSelectedFromSearcher');
        let plansToFilter = walletPlans.map((result) => {
            return result.getIn(['comercialData','DGSCode'])
        });
        return (
            <div className="broker-transfer-pension-plans-external-step1">
                <div className="broker-transfer-pension-plans-external-step1">
                    <OKBoxTitle
                        className="broker-transfer-pension-plans-external-step1__title"
                        value={formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_externalStep1Title')} />
                    <div className="broker-transfer-pension-plans-external-step1__info">
                        <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step1SelectPlanA" />
                    </div>
                </div>
                <div className="broker-transfer-pension-plans-external-step1">
                    <div className="broker-transfer-pension-plans-external-step1__input-search">
                        <BrokerAdvancedSearchExplore
                            plansToFilter={plansToFilter}
                            selectedNewPlan={planSelected}
                            fromPlansTransfer={true}
                            onHandleProductSelect={handlePlanSelectFromSearch}
                            isExternalPlansTransferOrigin={true}
                        >
                        </BrokerAdvancedSearchExplore>
                    </div>
                </div>
                {this.uploadDocumentSection()}
            </div>
        );
    }
}

BrokerTransferPensionPlansExternalStep1.propTypes = {
    immStep: PropTypes.object,
    addFile: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    walletPlans: PropTypes.object,
    setDescription: PropTypes.func.isRequired,
    handlePlanSelectFromSearch: PropTypes.func.isRequired,
}

module.exports = BrokerTransferPensionPlansExternalStep1;